(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nap-diner-faq-tabs"] && !Shopify.designMode) return;
  try {
    
function initNdFaqTabs(root){
  if(!root || root.dataset.ready==='true') return;
  root.dataset.ready='true';
  const tabs=[...root.querySelectorAll('[data-nd-tab]')];
  const panels=[...root.querySelectorAll('[data-nd-panel]')];
  tabs.forEach(tab=>tab.addEventListener('click',()=>{
    const value=tab.dataset.ndTab;
    tabs.forEach(item=>item.setAttribute('aria-selected',String(item===tab)));
    panels.forEach(panel=>panel.classList.toggle('is-hidden',panel.dataset.ndPanel!==value));
  }));
}
document.querySelectorAll('[data-nd-faq-tabs]').forEach(initNdFaqTabs);
document.addEventListener('shopify:section:load',event=>initNdFaqTabs(event.target.querySelector?.('[data-nd-faq-tabs]')));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nap-diner-home-hero"] && !Shopify.designMode) return;
  try {
    
function initNdSlider(root){
  if(!root || root.dataset.ready==='true') return;
  root.dataset.ready='true';
  const track=root.querySelector('[data-nd-track]');
  const slides=[...root.querySelectorAll('[data-nd-slide]')];
  const dots=[...root.querySelectorAll('[data-nd-dot]')];
  if(!track || slides.length<2) return;
  const setActive=index=>dots.forEach((dot,i)=>dot.classList.toggle('is-active',i===index));
  setActive(0);
  dots.forEach((dot,index)=>dot.addEventListener('click',()=>slides[index]?.scrollIntoView({behavior:'smooth',block:'nearest',inline:'start'})));
  const observer=new IntersectionObserver(entries=>{
    let best=null;
    entries.forEach(entry=>{if(entry.isIntersecting && (!best || entry.intersectionRatio>best.intersectionRatio)) best=entry;});
    if(best){const index=slides.indexOf(best.target);if(index>-1)setActive(index);}
  },{root:track,threshold:[.55,.75,.9]});
  slides.forEach(slide=>observer.observe(slide));
}
document.querySelectorAll('[data-nd-slider]').forEach(initNdSlider);
document.addEventListener('shopify:section:load',event=>initNdSlider(event.target.querySelector?.('[data-nd-slider]')));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nap-diner-pet-gallery"] && !Shopify.designMode) return;
  try {
    
function initNdPetGallery(root){
  if(!root || root.dataset.ready==='true') return;
  root.dataset.ready='true';
  const cards=[...root.querySelectorAll('[data-nd-pet-card]')];
  const ratios=new Map(cards.map(card=>[card,0]));
  cards.forEach(card=>{
    const video=card.querySelector('video');
    if(video){
      video.muted=true;
      video.loop=true;
      video.setAttribute('playsinline','');
    }
  });
  const sync=()=>{
    let active=null;
    let best=0;
    cards.forEach(card=>{
      const ratio=ratios.get(card)||0;
      if(ratio>best){best=ratio;active=card;}
    });
    if(best<0.55) active=null;
    cards.forEach(card=>{
      const video=card.querySelector('video');
      const isActive=card===active;
      card.classList.toggle('is-active',isActive);
      if(!video) return;
      if(isActive){
        const promise=video.play();
        if(promise?.catch) promise.catch(()=>{});
      }else{
        video.pause();
      }
    });
  };
  const observer=new IntersectionObserver(entries=>{
    entries.forEach(entry=>ratios.set(entry.target,entry.intersectionRatio));
    sync();
  },{threshold:[0,.25,.55,.75,1],rootMargin:'0px -8% 0px -8%'});
  cards.forEach(card=>observer.observe(card));
}
document.querySelectorAll('[data-nd-pet-gallery]').forEach(initNdPetGallery);
document.addEventListener('shopify:section:load',event=>initNdPetGallery(event.target.querySelector?.('[data-nd-pet-gallery]')));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nap-diner-product"] && !Shopify.designMode) return;
  try {
    
function initNapDinerProduct(root){
  if(!root || root.dataset.ndProductReady==='true') return;
  root.dataset.ndProductReady='true';
  const primary=root.querySelector('[data-nd-primary-add]');
  const sticky=root.querySelector('[data-nd-sticky]');
  if(!primary || !sticky) return;
  const observer=new IntersectionObserver(entries=>{
    const entry=entries[0];
    const mobile=window.matchMedia('(max-width: 749px)').matches;
    sticky.classList.toggle('is-visible',mobile && !entry.isIntersecting && window.scrollY>160);
  },{threshold:.15});
  observer.observe(primary);
  window.addEventListener('resize',()=>{if(!window.matchMedia('(max-width: 749px)').matches) sticky.classList.remove('is-visible');},{passive:true});
}
document.querySelectorAll('[data-nd-product]').forEach(initNapDinerProduct);
document.addEventListener('shopify:section:load',event=>initNapDinerProduct(event.target.querySelector?.('[data-nd-product]')));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nap-diner-reels"] && !Shopify.designMode) return;
  try {
    
function initNapDinerReels(root){
  if(!root || root.dataset.ndReady==='true') return;
  root.dataset.ndReady='true';
  const cards=[...root.querySelectorAll('[data-nd-reel]')];
  const ratios=new Map(cards.map(card=>[card,0]));
  const sync=()=>{
    let active=null,best=0;
    cards.forEach(card=>{const ratio=ratios.get(card)||0;if(ratio>best){best=ratio;active=card;}});
    if(best<0.55) active=null;
    cards.forEach(card=>{
      const video=card.querySelector('video');
      if(!video) return;
      if(card===active){video.muted=true;const p=video.play();if(p?.catch)p.catch(()=>{});}
      else{video.pause();try{video.currentTime=0;}catch(e){}}
    });
  };
  const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>ratios.set(entry.target,entry.intersectionRatio));sync();},{threshold:[0,.25,.55,.75,1],rootMargin:'0px -8% 0px -8%'});
  cards.forEach(card=>observer.observe(card));
}
document.querySelectorAll('[data-nd-reels]').forEach(initNapDinerReels);
document.addEventListener('shopify:section:load',event=>initNapDinerReels(event.target.querySelector?.('[data-nd-reels]')));

  } catch(e) { console.error(e); }
})();
})();
